
// LIVE URL
// export const baseURL = 'https://devapigobooze.codefactstech.com/admin';

// export const baseURL = 'http://localhost:3007'
export const baseURL = 'https://apigaruda.codefactstech.com'
// export const baseURL = 'http://43.204.66.246:4003'

export const getPublicS3Url = (fileKey = '') => {
  if (!fileKey) return '';
  
  // If it's already an S3 URL, return as-is
  if (fileKey.startsWith('http://') || fileKey.startsWith('https://')) {
    return fileKey;
  }
  
  // If it's an old absolute file path (contains /var/www or similar), extract just the filename with timestamp
  if (fileKey.startsWith('/') || fileKey.includes('/var/www')) {
    const parts = fileKey.split('/');
    const filename = parts[parts.length - 1];
    // For old paths, we need to handle them differently - they might be local files
    // Try to construct the S3 path from the filename
    console.warn('Old absolute path detected:', fileKey);
    // These old files might not be in S3, so return a placeholder or handle locally
    // For now, return the original path as a fallback
    return fileKey;
  }
  
  // For relative paths (new S3 uploads), prepend S3 bucket URL
  return `https://luxorace-pro.s3.ap-south-1.amazonaws.com/${fileKey}`;
};

export const productBaseURL = "https://devapigobooze.codefactstech.com/product/v1";
export const variantsBaseURL = "https://devapigobooze.codefactstech.com/product/v1/variants";
export const orderURL = 'https://devapigobooze.codefactstech.com/order/api/orders';
export const GOOGLE_MAP_API_KEY = "AIzaSyCtTH8DV1-h4tYTSb-geYjdn71a0Up_63k"

// LOCAL URL 
//  export const baseURL = 'http://localhost:9000';
// export const productBaseURL = "http://localhost:3500/v1";
//  export const orderURL = 'http://localhost:5002/api/orders';
// export const variantsBaseURL = "http://localhost:3500/v1/variants";
export const imageURL = 'https://gobooze-bucket.s3.eu-north-1.amazonaws.com/goboozestore/';


// export const imageURL = 'https://d12keppzk8wa17.cloudfront.net/goboozestore/';
